import React from 'react';
import { connect } from 'react-redux';
import ReclamationsPage from './ReclamationsPage';


const ReclamationsPageContainer = ({filtre}) => {

    return (<ReclamationsPage filtre={filtre} />);
};


const mapStateToProps = state => ({
    filtre: state.reclamation.reclamations.recherche.criteres.filtre
});


export default connect(mapStateToProps, null)(ReclamationsPageContainer);